
export default {
  name: 'ToolbarLayout',
  data() {
    return {
      urlEtaxWebPortal: process.env.urlEtaxWebPortal,
      urlEtaxPackage: process.env.urlEtaxPackage,
      urlEtaxSP: process.env.urlEtaxSP,
      urlEtaxRegister: process.env.urlEtaxRegister,
      urlEtaxRegisterSelfService: process.env.urlEtaxRegisterSelfService,
      urlHostname: process.env.urlHostname,
      sheet: false,
      listmenu: [
        // ! disable เอาไปใช้ทั้ง disable และ show
        {
          title: 'ETAX.ONE.TH',
          icon: 'mdi-home',
          path: '/',
          mode: 'internal',
          submenu: false,
          disable: false,
        },
        {
          title: 'SERVICE ',
          icon: 'mdi-toolbox-outline',
          path: '/eTaxService',
          mode: 'internal',
          submenu: false,
          disable: false,
        },
        {
          title: 'Investor Relations',
          icon: 'mdi-account-group',
          path: '/shareholder',
          mode: 'internal',
          submenu: false,
          disable: false,
        },
        {
          title: 'Contact Us',
          icon: 'mdi-face-agent',
          path: '/ContactToEtax',
          mode: 'internal',
          submenu: false,
          disable: false,
        },
        {
          title: 'Register',
          icon: 'mdi-account-plus',
          path: '',
          submenu: true,
          disable: false,
          children: [
            {
              icon: '',
              title: 'Register One Platform',
              path: process.env.urlEtaxRegister,
              mode: 'external',
              newtab: true,
              disable: false,
            },
            {
              icon: '',
              title: 'Register Self Service',
              path: process.env.urlEtaxRegisterSelfService,
              mode: 'external',
              newtab: true,
              disable: false,
            },
          ],
        },
        {
          title: 'Log in',
          icon: 'mdi-account',
          path: '',
          submenu: true,
          type: ['OB-', 'INET-'],
          disable: false,
          children: [
            {
              icon: '',
              title: 'Log in portal',
              path: process.env.urlEtaxWebPortal,
              mode: 'external',
              newtab: false,
              disable: false,
            },
            {
              icon: '',
              title: 'Log in package',
              path: process.env.urlEtaxPackage,
              newtab: true,
              mode: 'external',
              disable: false,
            },
            {
              icon: '',
              title: 'Log in etaxsp',
              path: process.env.urlEtaxSP,
              newtab: true,
              mode: 'external',
              disable: false,
            },
          ],
        },
      ],
      listLang: [
        { title: 'EN', text: 'English', flag: 'fi fi-us' },
        { title: 'TH', text: 'Thailand', flag: 'fi fi-th' },
      ],
    }
  },
  mounted() {
    if ('channel' in this.$route.query) {
      const id = this.$route.query.channel
      this.$router.push('/ContactToEtax?channel=' + id || '')
    }
  },
  methods: {
    fn_goto(_path, _mode, _newtab) {
      if (_mode === 'external') {
        if (_newtab === true) {
          window.open(_path, '_blank')
        } else {
          window.location.assign(_path)
        }
      } else {
        this.$router.push(_path)
      }
    },
    fn_changeLanguage(_lang) {
      if (_lang === 'TH') {
        localStorage.setItem('lang', 'th')
        this.$i18n.locale = localStorage.getItem('lang')
      } else if (_lang === 'EN') {
        localStorage.setItem('lang', 'en')
        this.$i18n.locale = localStorage.getItem('lang')
      }
    },
  },
}
